import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=a2f4d172"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=a2f4d172&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports